'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct16 from "./scala.-Product16.js";
var $p;
/** @constructor */
function $c_T16(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16) {
  this.nB = null;
  this.nJ = null;
  this.nK = null;
  this.nL = null;
  this.nM = null;
  this.nN = null;
  this.nO = null;
  this.nP = null;
  this.nQ = null;
  this.nC = null;
  this.nD = null;
  this.nE = null;
  this.nF = null;
  this.nG = null;
  this.nH = null;
  this.nI = null;
  this.nB = _1;
  this.nJ = _2;
  this.nK = _3;
  this.nL = _4;
  this.nM = _5;
  this.nN = _6;
  this.nO = _7;
  this.nP = _8;
  this.nQ = _9;
  this.nC = _10;
  this.nD = _11;
  this.nE = _12;
  this.nF = _13;
  this.nG = _14;
  this.nH = _15;
  this.nI = _16;
}
export { $c_T16 as $c_T16 };
$p = $c_T16.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T16;
/** @constructor */
function $h_T16() {
}
export { $h_T16 as $h_T16 };
$h_T16.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 16;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct16.$f_s_Product16__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 499793902, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T16) && ((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nB, x$0.nB) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nJ, x$0.nJ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nK, x$0.nK)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nL, x$0.nL)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nM, x$0.nM)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nN, x$0.nN)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nO, x$0.nO)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nP, x$0.nP)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nQ, x$0.nQ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nC, x$0.nC)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nD, x$0.nD)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nE, x$0.nE)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nF, x$0.nF)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nG, x$0.nG)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nH, x$0.nH)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.nI, x$0.nI))));
});
$p.o = (function() {
  return "Tuple16";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((("(" + this.nB) + ",") + this.nJ) + ",") + this.nK) + ",") + this.nL) + ",") + this.nM) + ",") + this.nN) + ",") + this.nO) + ",") + this.nP) + ",") + this.nQ) + ",") + this.nC) + ",") + this.nD) + ",") + this.nE) + ",") + this.nF) + ",") + this.nG) + ",") + this.nH) + ",") + this.nI) + ")");
});
function $isArrayOf_T16(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eF)));
}
export { $isArrayOf_T16 as $isArrayOf_T16 };
var $d_T16 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T16, "scala.Tuple16", ({
  eF: 1,
  b: 1,
  c: 1,
  rO: 1,
  a: 1
}));
export { $d_T16 as $d_T16 };
